export default __webpack_public_path__ + "static/media/facomMenuLogo.08739d79.png";